import React from 'react';

import { MainLayout } from '@containers';

const Main: React.FunctionComponent = (): JSX.Element => {
  return <MainLayout />;
};

export default Main;
